import Image from "next/image";

type LogoProps = {
  variant?: "default" | "golden";
};

export function Logo({ variant = "default" }: LogoProps) {
  return (
    <Image
      src={variant === "default" ? "/logo.svg" : "/golden-logo.svg"}
      alt="Traqly"
      width={126}
      height={32}
      style={{ aspectRatio: 126 / 32 }}
      priority
    />
  );
}
